import { render, staticRenderFns } from "./PriceRange.vue?vue&type=template&id=532ef4df"
import script from "./PriceRange.vue?vue&type=script&lang=js"
export * from "./PriceRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports